import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { TVideoBlockDesktop } from '../models';

export const VideoBlock: FC<TVideoBlockDesktop> = ({
    Layout,
    Text,
    VideoPlayer,
    backgroundImage,
    styles,
    title,
    videoSettings,
}) => {
    return (
        <>
            <Layout
                classNames={{
                    layout: cn(styles.external, styles.header),
                }}
            >
                <Text styler={{ marginTop: 0, marginBottom: 0 }} tag="h3" view="medium">
                    {title}
                </Text>
            </Layout>
            <Layout
                classNames={{
                    layout: cn(styles.external, styles.layout),
                    layoutContent: cn(styles.external, styles.layoutContent),
                }}
                style={
                    backgroundImage
                        ? {
                              backgroundImage: `url(${backgroundImage})`,
                          }
                        : undefined
                }
            >
                <div className={styles.videoContainer}>
                    <VideoPlayer className={cn(styles.external, styles.video)} {...videoSettings} />
                </div>
            </Layout>
        </>
    );
};
